<div class="tipShade" *ngIf="type==='tip'">
	<div class="tip">
	  <div class="tiptxt" [ngClass]= "{ 'text-Align-Left': tipType == 'showUrl'}" [innerHtml]="desText"></div>
      <button id="quitBtn" class="btnWord" (click)="sure()" *ngIf="sureText!=''">{{sureText}}</button>
      <button id="continueBtn" class="btnWord" (click)="cancel()" *ngIf="cancelText!=''">{{cancelText}}</button>
	</div>
</div>

<div class="toast {{theme}}" id="toast" *ngIf="type==='toast'" [innerHTML]="desText" ></div>

<div class="tipShade" *ngIf="type==='maskTip'">
	<div class="tip">
	  <div class="tiptxt" [innerHtml]="desText"></div>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/component/tip/component.tip.html